// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import agent package modal (memo dev/36). */

.ZxHipj_hmIDXbYkQWdEW {
  padding: 4px 8px 8px;
  min-width: 380px;
}

.YfNUeDwklyU7NydNlIO_ {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 600;
  color: var(--curio-text-primary, var(--curio-text-primary));
}

.LFMAQlkDopHGjQ4o3reQ {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.oNIJQDARuilcRFedq63a input {
  font-size: 12px;
}

.UoMcX8aLWgVKqaF8xbX_ {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--curio-text-primary, var(--curio-text-primary));
  background: var(--curio-surface-muted);
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  padding: 8px 10px;
}

/* Inline reset for the accumulating selection: a plain text control inside the
   summary line, not a third button competing with Cancel/Import in the footer. */
.VEftfTDwMl_xXV3s9Vrj {
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: var(--curio-text-secondary);
  text-decoration: underline;
  cursor: pointer;
}

.VEftfTDwMl_xXV3s9Vrj:hover {
  color: var(--curio-text-primary);
}

.MGMZNGtP0oJCwRsTRVeA {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--curio-danger-text);
  white-space: pre-wrap;
}

.PKY1eQ0jJDq2Ce0alhwK {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.bRXI36W4evQPtvh9VQzG {
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary, var(--curio-text-primary));
  cursor: pointer;
}

.COkB8p4thjIQOsrwSrel {
  border: none;
  border-radius: 999px;
  padding: 6px 18px;
  font-size: 12px;
  font-weight: 600;
  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
  cursor: pointer;
}

.COkB8p4thjIQOsrwSrel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/catalog/AgentImportModal.module.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;iFACiF;AACjF;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4DAA4D;EAC5D,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Import agent package modal (memo dev/36). */\n\n.body {\n  padding: 4px 8px 8px;\n  min-width: 380px;\n}\n\n.title {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--curio-text-primary, var(--curio-text-primary));\n}\n\n.hint {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.picker input {\n  font-size: 12px;\n}\n\n.summary {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  background: var(--curio-surface-muted);\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  padding: 8px 10px;\n}\n\n/* Inline reset for the accumulating selection: a plain text control inside the\n   summary line, not a third button competing with Cancel/Import in the footer. */\n.clear {\n  margin-left: 6px;\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  color: var(--curio-text-secondary);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.clear:hover {\n  color: var(--curio-text-primary);\n}\n\n.error {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: var(--curio-danger-text);\n  white-space: pre-wrap;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.cancel {\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary, var(--curio-text-primary));\n  cursor: pointer;\n}\n\n.import {\n  border: none;\n  border-radius: 999px;\n  padding: 6px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n  cursor: pointer;\n}\n\n.import:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `ZxHipj_hmIDXbYkQWdEW`,
	"title": `YfNUeDwklyU7NydNlIO_`,
	"hint": `LFMAQlkDopHGjQ4o3reQ`,
	"picker": `oNIJQDARuilcRFedq63a`,
	"summary": `UoMcX8aLWgVKqaF8xbX_`,
	"clear": `VEftfTDwMl_xXV3s9Vrj`,
	"error": `MGMZNGtP0oJCwRsTRVeA`,
	"footer": `PKY1eQ0jJDq2Ce0alhwK`,
	"cancel": `bRXI36W4evQPtvh9VQzG`,
	"import": `COkB8p4thjIQOsrwSrel`
};
export default ___CSS_LOADER_EXPORT___;
